import { render, staticRenderFns } from "./Extra-coming-soon.vue?vue&type=template&id=7de5892a&"
import script from "./Extra-coming-soon.vue?vue&type=script&lang=js&"
export * from "./Extra-coming-soon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports